export enum OrganismeStatutEtapier {
  ETAPE_1 = 'ETAPE_1',
  ETAPE_2 = 'ETAPE_2',
  ETAPE_3 = 'ETAPE_3',
  ETAPE_4 = 'ETAPE_4',
  TERMINER = 'TERMINER',
}

export const DECLARATION_STATUT_ETAPIER = [
  OrganismeStatutEtapier.ETAPE_4,
  OrganismeStatutEtapier.TERMINER,
];